<template>
    <div>
        <div class="file_box" v-for="(document, index) in documents" @click.prevent="onClickPreviewFile({index})">
            <a href="#" class="file"><span class="txt">{{ document.fileName }}</span></a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ResponseFile",

        props: {
            documents: {
                type: Array,
                required: true
            }
        },

        methods: {
            onClickPreviewFile({index}) {
                this.$eventBus.$emit('clickPreviewFile', {index});
            }
        }
    }
</script>

<style scoped>

</style>